import { toIsoDate } from "./dateUtils";

/**
 * Merges RHF `data` with `additionalData` from status actions (e.g. ApplicationFormFooter
 * "Completed" passes reviewedBySignedAt from props). Merge first so values stay consistent.
 *
 * @param {Record<string, unknown>} data
 * @param {Record<string, unknown>} [additionalData]
 * @returns {Record<string, unknown>}
 */
export function mergeFormDataWithStatusExtras(data, additionalData = {}) {
  return { ...data, ...additionalData };
}

/**
 * Maps listed top-level keys on `merged` through `toIsoDate`. Use after merge so
 * `additionalData` cannot overwrite full ISO strings with raw YYYY-MM-DD.
 *
 * @param {Record<string, unknown>} merged
 * @param {string[]} keys
 * @returns {Record<string, unknown>} patch object to spread onto payload
 */
export function applyIsoDatesToFields(merged, keys) {
  const patch = {};
  for (const key of keys) {
    if (key in merged) {
      patch[key] = toIsoDate(merged[key]);
    }
  }
  return patch;
}

/**
 * One-step helper for simple application forms: merge + ISO date fields + optional flag.
 *
 * @param {Record<string, unknown>} data
 * @param {Record<string, unknown>} [additionalData]
 * @param {string[]} isoDateFields
 * @param {{ flag?: string; flagField?: string }} [options]
 */
export function buildPayloadWithIsoDates(
  data,
  additionalData = {},
  isoDateFields = [],
  options = {}
) {
  const merged = mergeFormDataWithStatusExtras(data, additionalData);
  const { flag, flagField = "flag" } = options;
  const payload = {
    ...merged,
    ...applyIsoDatesToFields(merged, isoDateFields),
  };
  if (flag !== undefined) {
    payload[flagField] = flag;
  }
  return payload;
}
